
export default {
    name: 'ConfirmDepositDialog',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        detail: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        player() {
            return this.$store.state.player.player
        },
    },
}
